
  // src/utils/urlPhone.ts

/** Returns raw query param or null */
export function getQueryParam(name: string): string | null {
  const params = new URLSearchParams(window.location.search);
  const val = params.get(name);
  return val ? decodeURIComponent(val) : null;
}

/** Validate Kenyan phone number:
 *  Accepts:
 *   - 07XXXXXXXX  (10 digits, local)
 *   - 2547XXXXXXXX (12 digits, no plus)
 *   - +2547XXXXXXXX (13 chars including +)
 */
export function isValidPhoneKE(phone: string): boolean {
  const p = phone.replace(/[\s\-]/g, ''); // strip spaces/dashes
  return /^(?:07\d{8}|(?:\+254|254)7\d{8})$/.test(p);
}

/** Normalize accepted formats into the local 07XXXXXXXX form.
 *  Returns normalized phone or null if invalid.
 */
export function normalizePhoneToLocal(phone: string): string | null {
  if (!phone) return null;
  let p = phone.replace(/[\s\-]/g, ''); // remove spaces and dashes

  if (!isValidPhoneKE(p)) return null;

  // +2547xxxxxxxx  -> 07xxxxxxxx
  if (p.startsWith('+254')) return '0' + p.slice(4);
  // 2547xxxxxxxx   -> 07xxxxxxxx
  if (p.startsWith('254')) return '0' + p.slice(3);
  // Already local form 07xxxxxxxx
  return p;
}

/** Load phone from URL or localStorage, validate (Kenya) and persist normalized form.
 *  Removes phone from URL after loading for privacy.
 */
export function loadPhoneFromUrlOrStorage(): string | null {
  

  const phoneFromUrl = getQueryParam('phone');
  if (!phoneFromUrl){
    const stored = localStorage.getItem('player_phone');
    if (stored && isValidPhoneKE(stored)) {
      const normalized = normalizePhoneToLocal(stored);
      if (normalized) return normalized;

    }
    return null;
  }

  const normalized = normalizePhoneToLocal(phoneFromUrl);
  if (!normalized) return null;

  // persist normalized local form
  localStorage.setItem('player_phone', normalized);

  // Remove phone param from URL for privacy
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('phone');
    window.history.replaceState({}, document.title, url.toString());
  } catch (e) {
    // ignore older browsers
  }

  return normalized;
}

/** Optional helper: clear stored phone */
export function clearStoredPhone(): void {
  localStorage.removeItem('player_phone');
}

